(function(){
  function initBwhCarousel(){
    // 1) Find each blog-content container
    const containers = document.querySelectorAll('.article__content-inner');
    if (!containers.length) return;

    containers.forEach(container => {
      let idx = 0;
      // 2) Replace shortcode with carousel wrapper
      container.innerHTML = container.innerHTML.replace(
        /\[collection-carousel="([^"]+)"\]/g,
        (_, handle) => {
          const id = `bwh-carousel-${handle}-${idx++}`;
          return `
            <div id="${id}" class="bwh-slider-wrapper bwh-slider-carousel" data-handle="${handle}">
              <div class="swiper swiper-container">
                <div class="swiper-wrapper"></div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          `;
        }
      );
    });

    // 3) For each wrapper, fetch products & build slides
    document.querySelectorAll('.bwh-slider-wrapper').forEach(wrapper => {
      const handle    = wrapper.dataset.handle;
      const swiperEl  = wrapper.querySelector('.swiper-container');
      const trackEl   = wrapper.querySelector('.swiper-wrapper');

      fetch(`/collections/${handle}/products.json`)
        .then(r => r.json())
        .then(data => {
          (data.products || []).forEach(prod => {
            // pick second image if available, else first, else blank
            const imgSrc = prod.images?.[0]?.src
                         || prod.images?.[0]?.src
                         || '';

            const price  = prod.variants?.[0]?.price || '0.00';
            const slide  = document.createElement('div');
            slide.className = 'swiper-slide article--product-card';

            slide.innerHTML = `
              <div class="product-image">
                ${imgSrc ? `<a href="/products/${prod.handle}"><img src="${imgSrc}" alt="${prod.title}" loading="lazy"></a>` : ''}
              </div>
              <div class="product-info">
                <div class="product-name"><a href="/products/${prod.handle}">${prod.title}</a></div>
                <div class="product-prices">$${price}</div>
                <div class="product-atc"><a href="/products/${prod.handle}" class="purchase-btn">Buy Now</a></div>
              </div>
            `;
            trackEl.appendChild(slide);
          });

          // 4) initialize Swiper
          new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            }
          });
        });
    });
  }

  document.addEventListener('DOMContentLoaded', initBwhCarousel);
})();